(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["collection-hub"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('collection-hub')) {
  customElements.define(
    'collection-hub',
    class CollectionHub extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;
        this.initialized = true;
        this.param = this.dataset.param || 'sub';
        this.parentPath = window.location.pathname;
        this.tabs = [...this.querySelectorAll('[role="tab"][data-hub-sub]')];
        this.toggles = [...this.querySelectorAll('[data-hub-toggle]')];
        this.cards = [...this.querySelectorAll('.collection-hub__card')];
        this.gridSlot = this.querySelector('[data-hub-grid-slot]');
        this.attachParentGrid();
        this.patchFacets();
        if (!this.tabs.length) return;

        // Static child panels are SSR fallback only; live view uses CollectionProductGrid
        if (this.subsPanels) this.subsPanels.hidden = true;

        this.tabs.forEach((tab) => {
          tab.addEventListener('click', (event) => {
            if (event.target.closest('[data-hub-ignore]')) return;
            event.preventDefault();
            this.select(tab.dataset.hubSub, true);
          });
        });

        this.toggles.forEach((btn) => {
          btn.addEventListener('click', (event) => {
            event.preventDefault();
            const handle = btn.dataset.hubToggle;
            const card = btn.closest('.collection-hub__card');
            if (card && card.classList.contains('is-active')) {
              this.select('', true);
            } else {
              this.select(handle, true);
            }
          });
        });

        window.addEventListener('popstate', () => {
          this.select(this.handleFromUrl() || '', false);
        });

        document.addEventListener('krown:main-collection-grid:filtered', () => {
          this.bindEmptyClear();
          this.rewriteFacetClearLinks();
          this.syncGenderUi();
        });

        // Facet "Clear all" / pills are plain links — without this they navigate to the
        // child collection URL from the fetched section and the hub picker disappears.
        document.addEventListener(
          'click',
          (event) => {
            const link = event.target.closest('a.js-facet-remove');
            if (!link) return;
            if (!document.querySelector('collection-hub')) return;
            event.preventDefault();
            event.stopPropagation();
            this.onFacetRemoveClick(link, event);
          },
          true
        );

        this.select(this.handleFromUrl() || '', false);
        this.bindEmptyClear();
        this.rewriteFacetClearLinks();
        this.syncGenderUi();
      }

      genderFromUrl() {
        const value = new URLSearchParams(window.location.search).get('filter.v.t.shopify.target-gender') || '';
        if (value.includes('TaxonomyValue/19')) return 'male';
        if (value.includes('TaxonomyValue/18')) return 'female';
        return '';
      }

      syncGenderUi() {
        const gender = this.genderFromUrl();

        this.querySelectorAll('[data-hub-media-image]').forEach((img) => {
          const next =
            (gender === 'male' && img.dataset.maleSrc) ||
            (gender === 'female' && img.dataset.femaleSrc) ||
            img.dataset.defaultSrc ||
            '';
          const focal =
            (gender === 'male' && img.dataset.maleFocal) ||
            (gender === 'female' && img.dataset.femaleFocal) ||
            img.dataset.defaultFocal ||
            '50% 50%';
          if (next && img.getAttribute('src') !== next) {
            img.setAttribute('src', next);
            img.removeAttribute('srcset');
          }
          img.style.objectPosition = focal;
        });

        this.querySelectorAll('.collection-hub__teasers').forEach((row) => {
          const sets = [...row.querySelectorAll('[data-hub-teaser-set]')];
          const wanted = gender || 'default';
          let active = sets.find((set) => set.dataset.hubTeaserSet === wanted);
          if (active && !active.querySelector('.collection-hub__teaser')) {
            active = sets.find((set) => set.dataset.hubTeaserSet === 'default') || active;
          }
          sets.forEach((set) => {
            set.hidden = set !== active;
          });
        });
      }

      attachParentGrid() {
        const source = document.querySelector('[data-hub-collection-grid]');
        if (!source || !this.gridSlot) return;
        this.gridSlot.appendChild(source);
        source.hidden = false;
        this.parentGrid = source;
        this.productGrid = document.getElementById('CollectionProductGrid');
        this.productGridInner = document.getElementById('main-collection-product-grid');
        this.sectionId = this.productGridInner?.dataset.id || 'collection';
        this.subsPanels = this.querySelector('[data-hub-subs]');
      }

      patchFacets() {
        const FacetFiltersForm = customElements.get('facet-filters-form');
        if (!FacetFiltersForm) {
          customElements.whenDefined('facet-filters-form').then(() => this.patchFacets());
          return;
        }
        if (FacetFiltersForm.__hubPatched) return;
        FacetFiltersForm.__hubPatched = true;
        const hubParam = this.param;
        const originalRenderPage = FacetFiltersForm.renderPage;

        FacetFiltersForm.renderPage = (searchParams, event, updateURLHash = true) => {
          const hub = document.querySelector('collection-hub');
          const sub = hub?.handleFromUrl?.() || '';
          if (!sub) {
            originalRenderPage.call(FacetFiltersForm, searchParams, event, updateURLHash);
            return;
          }

          FacetFiltersForm.searchParamsPrev = searchParams;
          const sections = FacetFiltersForm.getSections();
          const grid = document.getElementById('main-collection-product-grid');
          grid?.classList.add(`${FacetFiltersForm._prefix}loading`);

          const fetchParams = new URLSearchParams(searchParams);
          fetchParams.delete(hubParam);

          sections.forEach((section) => {
            const qs = fetchParams.toString();
            const url = `/collections/${sub}?section_id=${section.section}${qs ? `&${qs}` : ''}`;
            const filterDataUrl = (element) => element.url === url;
            if (FacetFiltersForm.filterData.some(filterDataUrl)) {
              FacetFiltersForm.renderSectionFromCache(filterDataUrl, event);
            } else {
              FacetFiltersForm.renderSectionFromFetch(url, event);
            }
          });

          if (updateURLHash) {
            const params = new URLSearchParams(fetchParams);
            params.set(hubParam, sub);
            const qs = params.toString();
            history.pushState({ searchParams: qs }, '', `${window.location.pathname}${qs ? `?${qs}` : ''}`);
          }
        };
      }

      hubClearUrl() {
        const url = new URL(this.parentPath, window.location.origin);
        const sub = this.handleFromUrl();
        if (sub) url.searchParams.set(this.param, sub);
        return `${url.pathname}${url.search}`;
      }

      bindEmptyClear() {
        document.querySelectorAll('.collection-empty__action').forEach((btn) => {
          btn.href = this.hubClearUrl();
          if (btn.dataset.hubClearBound) return;
          btn.dataset.hubClearBound = '1';
          btn.addEventListener('click', (event) => {
            event.preventDefault();
            this.clearFilters(event);
          });
        });
      }

      rewriteFacetClearLinks() {
        document.querySelectorAll('.active-facets a.js-facet-remove').forEach((link) => {
          try {
            const url = new URL(link.href, window.location.origin);
            const isClearAll = !url.search || ![...url.searchParams.keys()].some((key) => key.startsWith('filter.'));
            if (isClearAll || url.pathname !== this.parentPath) {
              // Keep filter query (for single-pill remove) but always stay on the hub parent path
              const next = new URL(this.parentPath, window.location.origin);
              url.searchParams.forEach((value, key) => {
                if (key !== this.param) next.searchParams.set(key, value);
              });
              const sub = this.handleFromUrl();
              if (sub) next.searchParams.set(this.param, sub);
              if (isClearAll) {
                next.search = '';
                if (sub) next.searchParams.set(this.param, sub);
              }
              link.href = `${next.pathname}${next.search}`;
            }
          } catch (error) {
            // ignore bad hrefs
          }
        });
      }

      onFacetRemoveClick(link, event) {
        let query = '';
        try {
          const url = new URL(link.href, window.location.origin);
          const params = new URLSearchParams(url.search);
          params.delete(this.param);
          query = params.toString();
        } catch (error) {
          query = link.href.includes('?') ? link.href.slice(link.href.indexOf('?') + 1) : '';
        }
        this.renderFilters(query, event);
      }

      clearFilters(event) {
        this.renderFilters('', event);
      }

      renderFilters(query, event) {
        const FacetFiltersForm = customElements.get('facet-filters-form');
        if (FacetFiltersForm?.renderPage) {
          FacetFiltersForm.renderPage(query, event, true);
        } else {
          window.location.assign(this.hubClearUrl());
        }
      }

      handleFromUrl() {
        return new URLSearchParams(window.location.search).get(this.param) || '';
      }

      filterQuery() {
        const params = new URLSearchParams(window.location.search);
        params.delete(this.param);
        params.delete('page');
        return params.toString();
      }

      setActiveUi(handle) {
        const showingAll = !handle;

        this.tabs.forEach((tab) => {
          const on = !showingAll && tab.dataset.hubSub === handle;
          tab.setAttribute('aria-selected', on ? 'true' : 'false');
        });

        this.cards.forEach((card) => {
          const tab = card.querySelector('[role="tab"][data-hub-sub]');
          const toggle = card.querySelector('[data-hub-toggle]');
          const on = Boolean(tab && !showingAll && tab.dataset.hubSub === handle);
          card.classList.toggle('is-active', on);
          if (toggle) {
            const title = tab ? tab.getAttribute('title') || tab.dataset.hubSub : '';
            toggle.setAttribute(
              'aria-label',
              on ? this.dataset.clearLabel || 'Clear selection' : this.dataset.openLabel || title
            );
          }
        });

        if (this.productGrid) this.productGrid.hidden = false;
        if (this.subsPanels) this.subsPanels.hidden = true;
      }

      select(handle, push) {
        const valid = handle && this.tabs.some((tab) => tab.dataset.hubSub === handle);
        if (handle && !valid) handle = '';
        const showingAll = !handle;
        const current = this.handleFromUrl();

        this.setActiveUi(handle);

        if (push) {
          const url = new URL(window.location.href);
          if (showingAll) {
            url.searchParams.delete(this.param);
          } else {
            url.searchParams.set(this.param, handle);
            url.searchParams.delete('page');
          }
          if (current !== (handle || '') || (!showingAll && url.searchParams.get('page'))) {
            window.history.pushState({ hubSub: handle || '' }, '', url);
          }
        }

        this.loadCollectionView(handle);
      }

      async loadCollectionView(handle) {
        if (!this.sectionId || !this.productGrid) return;

        // Parent view is already SSR'd — only refetch after leaving it once
        if (!handle && !this._didLeaveParent) return;
        if (handle) this._didLeaveParent = true;

        const path = handle ? `/collections/${handle}` : this.parentPath;
        const filters = this.filterQuery();
        const url = `${path}?section_id=${encodeURIComponent(this.sectionId)}${filters ? `&${filters}` : ''}`;

        if (this._loadUrl === url) return;
        this._loadUrl = url;

        this.productGridInner?.classList.add('loading');

        try {
          const response = await fetch(url);
          const text = await response.text();
          if (this._loadUrl !== url) return;

          const doc = new DOMParser().parseFromString(text, 'text/html');
          this.applyCollectionDoc(doc);
        } catch (error) {
          console.warn('collection-hub: failed to load collection view', error);
        } finally {
          if (this._loadUrl === url) {
            this.productGridInner?.classList.remove('loading');
          }
        }
      }

      applyCollectionDoc(doc) {
        const replace = (selector) => {
          const live = document.querySelector(selector);
          const next = doc.querySelector(selector);
          if (live && next) live.innerHTML = next.innerHTML;
        };

        const newGrid = doc.getElementById('CollectionProductGrid');
        if (newGrid && this.productGrid) {
          this.productGrid.innerHTML = newGrid.innerHTML;
          this.productGrid.hidden = false;
          this.productGridInner = document.getElementById('main-collection-product-grid');
        }

        replace('.facets-sidebar .element--is-sticky');
        replace('#FacetFiltersForm');
        replace('#FacetFiltersFormMobile');
        replace('.active-facets-desktop');
        replace('.active-facets-mobile');

        this.bindEmptyClear();
        this.rewriteFacetClearLinks();

        document.dispatchEvent(
          new CustomEvent('krown:main-collection-grid:filtered', {
            bubbles: true,
            detail: { gridElement: this.productGrid },
          })
        );
      }
    }
  );
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["kit-builder"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('madone-kit-builder')) {
  customElements.define('madone-kit-builder', class extends HTMLElement {
    connectedCallback() {
      if(this.initialized) return;
      this.initialized = true;
      this.groups = {};
      this.querySelector('[data-cart-form]').addEventListener('submit', async e => {
        e.preventDefault();
        const selects = [...this.querySelectorAll('[data-size]')];
        if (!selects.every(select => select.reportValidity())) return;
        const items = selects.map(select => ({ id: Number(select.value), quantity: 1 }));
        const button = this.querySelector('.kb-add');
        const label = button.textContent;
        button.disabled = true;
        button.textContent = this.dataset.adding;
        this.querySelector('[data-cart-error]').textContent = '';
        try {
          if (this.dataset.themeCart) {
            const response = await fetch(this.dataset.cartAdd + '.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ items }) });
            const result = await response.json();
            if (!response.ok) throw new Error(result.description || this.dataset.error);
            window.location.assign(this.dataset.themeCart);
          } else {
            window.location.assign(this.dataset.cartBase + items.map(item => item.id + ':1').join(',') + '?storefront=true');
          }
        } catch (error) {
          this.querySelector('[data-cart-error]').textContent = error.message || this.dataset.error;
          button.disabled = false;
          button.textContent = label;
        }
      });

      for (const kind of ['jersey', 'bibs']) {
        const control = this.querySelector(`[data-control="${kind}"]`);
        const tiles = [...control.querySelectorAll('.kb-tile')];
        this.groups[kind] = { control, tiles, index: 0 };
        tiles.forEach((tile, i) => tile.addEventListener('click', () => this.select(kind, i)));
        control.querySelectorAll('[data-step]').forEach(button => button.addEventListener('click', () => this.select(kind, this.groups[kind].index + Number(button.dataset.step))));
        const track = control.querySelector('.kb-track');
        let scrollTimer;
        track.addEventListener('scroll', () => {
          clearTimeout(scrollTimer);
          scrollTimer = setTimeout(() => {
            const nearest = tiles.reduce((best, tile, i) => Math.abs(tile.offsetLeft - track.scrollLeft) < Math.abs(tiles[best].offsetLeft - track.scrollLeft) ? i : best, 0);
            this.select(kind, nearest, false);
          }, 140);
        });
        let drag;
        track.addEventListener('pointerdown', e => {
          if (e.pointerType !== 'mouse') return;
          drag = { x: e.clientX, scroll: track.scrollLeft, moved: false };
        });
        track.addEventListener('pointermove', e => {
          if (!drag) return;
          const distance = e.clientX - drag.x;
          if (Math.abs(distance) > 5) {
            drag.moved = true;
            track.setPointerCapture(e.pointerId);
            track.style.scrollSnapType = 'none';
            track.scrollLeft = drag.scroll - distance;
          }
        });
        const endDrag = () => {
          if (!drag) return;
          const moved = drag.moved;
          drag = null;
          track.style.scrollSnapType = '';
          if (moved) {
            const nearest = tiles.reduce((best, tile, i) => Math.abs(tile.offsetLeft - track.scrollLeft) < Math.abs(tiles[best].offsetLeft - track.scrollLeft) ? i : best, 0);
            this.select(kind, nearest);
          }
        };
        track.addEventListener('pointerup', endDrag);
        track.addEventListener('pointercancel', endDrag);
        track.addEventListener('dragstart', e => e.preventDefault());
        const zone = this.querySelector(`[data-kind="${kind}"]`);
        let start;
        zone.addEventListener('pointerdown', e => { start = { x: e.clientX, y: e.clientY }; });
        zone.addEventListener('pointerup', e => {
          if(start && Math.abs(e.clientX-start.x)>35 && Math.abs(e.clientX-start.x)>Math.abs(e.clientY-start.y)) this.select(kind,this.groups[kind].index+(e.clientX<start.x?1:-1));
          start = null;
        });
        zone.addEventListener('pointercancel', () => { start = null; });
        this.select(kind, 0, false);
      }
    }
    select(kind, next, scroll = true) {
      const group = this.groups[kind];
      if(!group.tiles.length) return;
      group.index = (next + group.tiles.length) % group.tiles.length;
      const tile = group.tiles[group.index];
      group.tiles.forEach((t,i) => t.setAttribute('aria-pressed', String(i===group.index)));

      const size = this.querySelector(`[data-size="${kind}"]`);
      if (size.dataset.product !== tile.dataset.url) {
        size.replaceChildren(new Option(this.dataset.choose, ''));
        for (const variant of JSON.parse(tile.dataset.variants || '[]')) {
          const option = new Option(variant.title + (variant.available ? '' : ' — ' + this.dataset.soldOut), String(variant.id));
          option.disabled = !variant.available;
          size.add(option);
        }
        size.dataset.product = tile.dataset.url;
        size.value = '';
      }
      const preview = this.querySelector(`[data-preview="${kind}"]`);
      preview.src = tile.dataset.image;
      preview.alt = tile.dataset.title;
      group.control.querySelector('[data-name]').textContent = tile.dataset.title;
      group.control.querySelector('[data-count]').textContent = `${String(group.index+1).padStart(2,'0')} / ${String(group.tiles.length).padStart(2,'0')}`;
      group.control.querySelector('[data-step="-1"]').disabled = group.tiles.length < 2;
      group.control.querySelector('[data-step="1"]').disabled = group.tiles.length < 2;
      for (const step of [-1, 1]) {
        const neighbor = group.tiles[(group.index + step + group.tiles.length) % group.tiles.length];
        const button = group.control.querySelector(`[data-step="${step}"]`);
        const img = button.querySelector('img');
        button.style.visibility = neighbor ? 'visible' : 'hidden';
        if (neighbor) {
          img.src = neighbor.dataset.image;
          button.querySelector('[data-neighbor-name]').textContent = neighbor.dataset.title;
        }
      }
      const link = this.querySelector(`[data-link="${kind}"]`);
      link.href = tile.dataset.url;
      if(scroll) {
        const track = tile.parentElement;
        track.scrollTo({left:tile.offsetLeft-track.offsetLeft-(track.clientWidth-tile.clientWidth)/2,behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'instant':'smooth'});
      }
    }
  });
}

  } catch(e) { console.error(e); }
})();
})();
